import { render, staticRenderFns } from "./outInDetails.vue?vue&type=template&id=64cf4ea4&scoped=true"
import script from "./outInDetails.vue?vue&type=script&lang=js"
export * from "./outInDetails.vue?vue&type=script&lang=js"
import style0 from "./outInDetails.vue?vue&type=style&index=0&id=64cf4ea4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf4ea4",
  null
  
)

export default component.exports